function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3289 17.2174L13.3921 9.73887L15.2861 8.31653C15.585 8.09199 15.8365 7.79938 16.0193 7.45747L16.1306 7.22188C16.2918 6.92137 16.265 6.56612 16.0605 6.29384C15.856 6.02156 15.5224 5.89674 15.2032 5.96493L14.9176 6.01154C14.5522 6.0892 14.2016 6.24879 13.9021 6.47367L12.0082 7.89601L4.53171 6.83279C4.15096 6.77864 3.77214 6.87579 3.46438 7.10691L2.92442 7.51241C2.84011 7.57572 2.7973 7.67991 2.81259 7.78374C2.82741 7.88789 2.898 7.97613 2.99734 8.01247L9.0401 10.2648C8.37524 10.8311 7.83696 11.3261 7.18211 11.9288L6.51151 12.547L4.2346 11.7344C4.14252 11.7019 4.04158 11.7172 3.96418 11.7753L3.50348 12.1213C3.43392 12.1735 3.39146 12.2551 3.3885 12.3424C3.38545 12.4304 3.42248 12.5143 3.48855 12.5706L5.45823 14.256L6.52767 16.6174C6.53644 16.6368 6.54706 16.6547 6.55951 16.6713C6.59861 16.7234 6.65418 16.7609 6.71848 16.7775C6.80353 16.7986 6.89375 16.7806 6.96331 16.7283L7.42401 16.3824C7.50141 16.3242 7.54467 16.2312 7.53828 16.1344L7.39122 13.7223L8.17416 13.2488C8.93463 12.7887 9.55962 12.4101 10.2889 11.9295L10.7681 18.3599C10.7757 18.4659 10.8409 18.5575 10.9359 18.6006C11.0317 18.6447 11.1437 18.6326 11.228 18.5693L11.768 18.1638C12.0758 17.9328 12.275 17.5965 12.3289 17.2174Z",
  fill: "white"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13.8289,
  height: 13.8289,
  fill: "white",
  transform: "translate(11.9077 0.764221) rotate(53.094)"
})));
function SvgAeroplaneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplaneIcon);
export default __webpack_public_path__ + "static/media/aeroplane-icon.ffb7d8d5.svg";
export { ForwardRef as ReactComponent };